/* RESPONSIBLE TEAM: team-frontend-tech */
export function initialize(applicationInstance) {
  applicationInstance.lookup('service:tracing');
}

export default {
  name: 'initialize-tracing',
  initialize,
};
